import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "../styles/services.css";
import "../styles/common.css";

// ✅ single source of truth
import { servicesData } from "../data/servicesData";

const Services = () => {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <section className="services-section" id="services">
      <div className="container">
        <div className="services-inner">
          <div className="services-header" data-aos="fade-up">
            <h2 className="services-title">Szolgáltatásaink</h2>
            <div className="title-underline"></div>
            <p className="services-subtext">
              Fedezze fel kiemelt kezeléseinket, amelyek a modern technológiát
              és a szakértelmet ötvözik a legmagasabb szintű páciensélmény
              érdekében.
            </p>
          </div>

          <div className="services-grid">
            {servicesData.map((service, index) => (
              <div
                className="service-card"
                key={service.slug}
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <h4>{service.hero.title}</h4>

                {/* Short homepage description */}
                <p>{service.card.content || service.seo.description}</p>

                <img
                  src={service.card.image}
                  alt={service.card.alt}
                  className="service-icon"
                />

                <div className="service-btn-wrapper">
                  <button onClick={() => navigate(service.path)}>Tovább</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
